// import ReactToPrint from "react-to-print";
// https://codesandbox.io/p/sandbox/react-simple-quiz-app-gbfef?file=%2Fsrc%2FApp.js%3A8%2C1
// https://opentdb.com/api_config.php
// import { registerLocale } from "react-datepicker";
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import React, { Component } from 'react';
import Navigation from '../screens/Navigation.jsx';
import Headroom from "react-headroom";
import DatePicker from 'react-datepicker';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
// import { MdEdit, MdDelete, MdComment } from "react-icons/md";
import Markdownkatexnew from "./Markdown.js";
// import App from "./App.js";
import { Modal, Row } from "react-bootstrap";
import { isAuth, isAsignature } from "../helpers/auth.js";
import 'react-datepicker/dist/react-datepicker.css';
//AIzaSyDcrm0RC8gXH5hm0lLCGQel38ygXsH61Xw
// import WindowFocusHandler from "./isvisible.js";

// import puter from "@heyputer/puter.js";
import Task from './taskUser.js';
import IA from './timer copy.js';
import Tassk from './taskUser copy.js';

import { parseISO } from "date-fns";
import TimeAgo from 'timeago-react';
import * as timeago from 'timeago.js';
import es from 'timeago.js/lib/lang/es';
timeago.register('es', es);

// import es from 'date-fns/locale/es';
// registerLocale('es', es);

export default class Theme extends Component {

	open = () => this.setState({ showModal: true });
	close = () => this.setState({ showModal: false });

	// constructor(props) {
	// super(props);
	// this.
	state = {
		stdaverages: [],
		showModal: false,
		updatable: false,
		// name: props.name,
		// status: props.status,
		nombre: "",
		contenido: "",
		task: "task",
		items: [
			{
				"prg": "¿Qué experimento mental propuso Erwin Schrödinger para ilustrar la paradoja de la superposición cuántica en la vida cotidiana?",
				"alt": [
					["El demonio de Maxwell"],
					["El gato de Schrödinger"],
					["El gemelo de Langevin"],
					["El cerebro de Boltzmann"]
				],
				"rpta": "El gato de Schrödinger"
			},
			{
				"prg": "¿Qué fenómeno físico demuestra que la luz y las partículas de materia pueden comportarse tanto como ondas como partículas?",
				"alt": [
					["La dualidad onda-partícula"],
					["El efecto Doppler"],
					["La ley de gravitación universal"],
					["El principio de conservación de la energía"]
				],
				"rpta": "La dualidad onda-partícula"
			}],
		www: "",
		solution: "solution",
		noww: new Date(),
		ber: "",
		themeall: "",
		fechaexa: new Date(),
		startDate: new Date(),
		timetest: "3",
		editing: false,
		isDisabled: false,
		integers: [],
		tassks: [],
		tasskstd: [],
		theme: [],
		title: "",
		description: "",
		articulo: { art1: 'el', art2: 'del', art3: 'al' },
		description: "",
		dateb: new Date(),
		datee: "",
		id: "",
		submit: "",
	};
	// }



	getNotes = async () => {
		await axios.get(
			`${process.env.REACT_APP_API_URL}/seccions/${this.props.match.params.theme}/${this.props.match.params.curse}/${isAuth()._id}`
		).then(res => {
			if (res.data.length === 0) {
				this.props.history.push(`/curso/${this.props.match.params.theme}`)
				// this.createatachTheme()
			} else {
				// console.log(res.data[0], "www");
				this.setState({
					id: res.data[0]._id,
					theme: res.data[0],
					tassks: res.data[0].tassks,
					timetest: res.data[0].timetest,
					tasskstd: res.data[0].tasskstd,
					dateb: parseISO(res.data[0].dateb),
					datee: parseISO(res.data[0].datee),
					title: res.data[0].title,
					description: res.data[0].description
				})
				this.setState({
					isDisabled: false
				});
				if (isAuth().rol === '1') {
					if (res.data[0].tassks.length < 1) {
						// this.ai()
					}
					this.getStdNativescalification()
				}
				console.log(res.data[0].tassks.length, "www");

			}
		}).catch((err) => {
			console.log(err.response.statusText);
			toast.error(`Error To Your Information ${err.response.statusText}`);
			if (err.response.status === 401) { }
		});

	};

	// ai = async () => {
	// 	const prompt = `Generar 21 preguntas sobre ${this.props.location.state.title}, que tenga la siguiente estructura [
	// 		{
	// 			"prg": "¿Qué experimento mental propuso Erwin Schrödinger para ilustrar la paradoja de la superposición cuántica en la vida cotidiana?",
	// 			"alt": [
	// 				["El demonio de Maxwell"],
	// 				["El gato de Schrödinger"],
	// 				["El gemelo de Langevin"],
	// 				["El cerebro de Boltzmann"]
	// 			],
	// 			"rpta": "El gato de Schrödinger"
	// 		},
	// 		{
	// 			"prg": "¿Qué fenómeno físico demuestra que la luz y las partículas de materia pueden comportarse tanto como ondas como partículas?",
	// 			"alt": [
	// 				["La dualidad onda-partícula"],
	// 				["El efecto Doppler"],
	// 				["La ley de gravitación universal"],
	// 				["El principio de conservación de la energía"]
	// 			],
	// 			"rpta": "La dualidad onda-partícula"
	// }]`
	// 	await axios.post(`${process.env.REACT_APP_API_URL}/users/userCr`, { prompt })
	// 		.then((res) => {
	// 			this.setState({
	// 				items: JSON.parse(res.data.response)
	// 			})
	// 			this.createTask()
	// 			console.log(res.data.response, "ai")
	// 			// setLoading(false);
	// 		})
	// 		.catch((err) => {
	// 			// toast.error(err);
	// 			// if (err.response.status === 401) {
	// 			// }
	// 		})
	// }


	async componentDidMount() {
		this.getNotes();
		document.title = isAsignature().title


		// curl "https://generativelanguage.googleapis.com/v1beta/models/gemini-flash-latest:generateContent" \
		// -H 'Content-Type: application/json' \
		// -H 'X-goog-api-key: AIzaSyDcrm0RC8gXH5hm0lLCGQel38ygXsH61Xw' \
		// -X POST \
		// -d '{
		//   "contents": [
		//     {
		//       "parts": [
		//         {
		//           "text": "Explain how AI works in a few words"
		//         }
		//       ]
		//     }
		//   ]
		// }'

		// axios.get('https://generativelanguage.googleapis.com/v1beta/models/gemini-flash-latest:generateContent').then(res => {
		// 	console.log(res.data.results)
		// }).catch((err) => {
		// 	toast.error(`Error To Your Information ${err.response.statusText}`);
		// });

	}



	submitTest = async e => {
		e.preventDefault();
		const Data = {
			title: 'this.props.location.state.title',
			description: this.state.description,
			dateb: this.state.dateb,
			datee: this.state.datee,
			timetest: this.state.timetest
		};
		await axios.put(`${process.env.REACT_APP_API_URL}/seccions/${this.state.id}`, Data).then(res => {
			this.close()
			this.getNotes()
			toast.info(res.data)
			console.log(res, "www")
		});
	};

	onTodoChange(www, wqw) {
		toast.info(www);
		console.log(www);
		toast.info(wqw);
		// this.setState({
		// 	[name]: value
		// });
	}

	calificationsimilar = async () => {
		var ntger = this.state.integers
		//console.log(this.photo.task)
		function calculateSimilaritywww(str1 = "", str2 = "") {
			let longer = str1.trim();
			let shorter = str2.trim();
			// let a1 = longer.toLowerCase().split(" ");
			// let b1 = shorter.toLowerCase().split(" ");
			//let result = a1.every((aa, i) => aa[0] === b1[i][0]);
			if (longer.length < shorter.length) [longer, shorter] = [shorter, longer];
			// var arr = [];
			let count = 0;
			for (var i = 0; i < longer.length; i++) {
				if (shorter && shorter.includes(longer[i])) {
					shorter = shorter.replace(longer[i], "")
					count++
				};
			}
			return {
				score: (count * 100) / longer.length
			}
		}
		var dattes = [];

		for (var j = 0; j < ntger.length; j++) {
			if (ntger[j].Usser[0].tassk.length >= 1) {
				dattes.push(Date.parse(ntger[j].Usser[0].tassk[0].createdAt))
			} else {
				console.log("www")
			}
		}


		for (var k = 0; k < ntger.length; k++) {
			this.charge = k + 1; //console.log(k,  this.charrge)
			if (ntger[k].Usser[0].tassk.length >= 1) {
				var www = [];
				var lenghtt = [];
				var ntgerwww = this.state.integers
				for (var j = 0; j < ntgerwww.length; j++) {
					if (ntgerwww[j].Usser[0].tassk.length >= 1 && ntgerwww[j].Usser[0].tassk[0]._id !== ntger[k].Usser[0].tassk[0]._id) {
						www.push(calculateSimilaritywww(ntgerwww[j].Usser[0].tassk[0].task, ntgerwww[k].Usser[0].tassk[0].task).score);
						lenghtt.push(ntgerwww[j].Usser[0].tassk[0].task.length);
					} else {
						www.push(0);
						lenghtt.push(0);
					}
				}
				var onepoint = (Math.max.apply(Math, dattes) - Math.min.apply(Math, dattes)) / 20
				var alcance = Date.parse(ntger[k].Usser[0].tassk[0].createdAt) - Math.min.apply(Math, dattes)
				const wsum = Object.values(www).reduce((a, b) => a + b, 0)
				var nota = 0.5 * (20 - wsum / (ntger.length - www.filter(w => w === 0).length) * (20 / 100)) + 0.3 * ntgerwww[k].Usser[0].tassk[0].task.length * 20 / Math.max(...lenghtt) + 0.2 * alcance / onepoint
				if (nota) {
					await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${ntger[k].Usser[0].tassk[0]._id}`, { task: ntger[k].Usser[0].tassk[0].task, solution: '', note: Math.round(nota) + '' }).then(res => {
						//console.log(res)
					})
				} else {
					//console.log('sin nota')
				}
				this.setState({
					ber: k + 1
				});
			} else {
				//console.log("www")
			}
		}
		this.getNotes()
	}

	calificationsolution = async () => {
		//this.loading = "false"
		//console.log(this.state.tassks[1].task)
		// var www = [];
		var ntger = this.state.integers

		function calculateSimilaritywww(str1 = "", str2 = "") {
			let longer = str1.trim();
			let shorter = str2.trim();
			// let a1 = longer.toLowerCase().split(" ");
			// let b1 = shorter.toLowerCase().split(" ");
			//let result = a1.every((aa, i) => aa[0] === b1[i][0]);
			if (longer.length < shorter.length) [longer, shorter] = [shorter, longer];
			// var arr = [];
			let count = 0;
			for (var i = 0; i < longer.length; i++) {
				if (shorter && shorter.includes(longer[i])) {
					shorter = shorter.replace(longer[i], "")
					count++
				};
			}
			return {
				score: (count * 100) / longer.length
			}
		}

		for (var k = 0; k < ntger.length; k++) {
			if (ntger[k].Usser[0].tassk.length >= 1) {
				var numero = Number(ntger[k].Usser[0].tassk[0].solution) ? Number(ntger[k].Usser[0].tassk[0].solution) : 0
				var similaroriginal = calculateSimilaritywww(this.state.tassks[numero].task, this.state.tassks[numero].solution).score
				var similar = calculateSimilaritywww(ntger[k].Usser[0].tassk[0].task, this.state.tassks[numero].task).score
				var nota = (similar - similaroriginal) / ((100 - similaroriginal) / 20)

				this.setState({
					ber: k + 1
				});
				//console.log(this.photo.tassks[numero].task,"new")
				if (nota) {
					//this.loading = "false"
					await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${ntger[k].Usser[0].tassk[0]._id}`, { task: ntger[k].Usser[0].tassk[0].task, solution: numero + '', note: Math.round(nota * 1000) / 1000 + '' }).then(res => {
						//console.log(res)
					})
				} else {
					console.log('wwwww')
				}
			} else {
				console.log('www');
			}
		}
		toast.dark('Calificado correctamente')
		this.getNotes()
	}



	calificationsolutionone = async (_id, taskk, solution) => {
		function calculateSimilaritywww(str1 = "", str2 = "") {
			let longer = str1.trim();
			let shorter = str2.trim();
			if (longer.length < shorter.length) [longer, shorter] = [shorter, longer];
			// var arr = [];
			let count = 0;
			for (var i = 0; i < longer.length; i++) {
				if (shorter && shorter.includes(longer[i])) {
					shorter = shorter.replace(longer[i], "")
					count++
				};
			}
			return {
				score: (count * 100) / longer.length
			}
		}
		var similaroriginal = calculateSimilaritywww(this.state.tassks[solution].task, this.state.tassks[solution].solution).score
		var similar = calculateSimilaritywww(taskk, this.state.tassks[solution].task).score
		console.log(this.state.tassks[solution].task, "new")
		var nota = (similar - similaroriginal) / ((100 - similaroriginal) / 20)
		console.log(nota)

		this.loading = "false"
		await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${_id}`, { task: taskk, solution: solution + '', note: Math.round(nota * 1000) / 1000 + '' }).then(res => {
			//console.log(res)
		})
		this.getNotes()
	}

	calificationclean = async () => {
		// var dattes = [];
		var ntger = this.state.integers

		for (var k = 0; k < ntger.length; k++) {
			if (ntger[k].Usser[0].tassk.length >= 1) {
				// var numero = Number(ntger[k].Usser[0].tassk[0].solution) ? Number(ntger[k].Usser[0].tassk[0].solution) : 0
				await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${ntger[k].Usser[0].tassk[0]._id}`, { task: ntger[k].Usser[0].tassk[0].task, solution: ntger[k].Usser[0].tassk[0].solution, note: '' }).then(res => {
					console.log(res)
				})
			} else {
				console.log('www');
			}
		}
		toast.dark('Notas limpiadas correctamente')
		this.getNotes()
	}


	createTask = async () => {
		console.log(this.state.themeall.dateb, this.state.themeall.datee)
		await axios.post(`${process.env.REACT_APP_API_URL}/tasks`, { note: "", task: this.state.task, items: this.state.items, solution: this.state.solution, theme: this.state.id, codetheme: this.props.match.params.curse, curse: this.props.match.params.theme, user: isAuth()._id, dateb: this.state.dateb, datee: this.state.datee })
			.then(res => {
				console.log(res)
			})
		this.getNotes()
	}

	createTaskstd = async (www) => {
		console.log(www)

		const addHoursToLocalTime = (hoursToAdd) => {
			const originalDate = new Date();
			if (hoursToAdd > 2) {
				originalDate.setMinutes(originalDate.getMinutes() + hoursToAdd);
				return originalDate.toISOString();
			} else {
				originalDate.setHours(originalDate.getHours() + hoursToAdd);
				return originalDate.toISOString();
			}
		};
		// const wwwww = new Date();
		const timestop = addHoursToLocalTime(this.state.timetest); // Example: Adding 3 hours to the current local time
		// console.log(parseISO(timestop), wwwww)
		// console.log(new Date().toISOString()); // to show what "now" is in ISO format
		// console.log(timestop);
		await axios.post(`${process.env.REACT_APP_API_URL}/tasks`, { note: "", task: this.state.task, items: www, solution: this.state.solution, theme: this.state.id, codetheme: this.props.match.params.curse, curse: this.props.match.params.theme, user: isAuth()._id, dateb: new Date(), datee: timestop })
			.then(res => {
				console.log(res)
				this.getNotes()

			})
	}

	getRandomIntInclusive = async (min, max) => {
		this.setState({
			isDisabled: true
		});
		const minCeiled = Math.ceil(min);
		const maxFloored = Math.floor(max);
		// The maximum is exclusive and the minimum is inclusive
		const rand = Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
		console.log(rand, min, max)
		const task = this.state.tassks[rand]
		// console.log(task.items)
		// this.setState({
		// 	items: task.items,
		// 	// solution: 'task.solution',
		// });
		if (this.state.tasskstd.length === 0) {
			this.createTaskstd(task.items)
		} else {
			toast.info("www")
		}

	}


	//clean tasks
	cleantasks = async () => {
		if (window.confirm('Desea eliminar las tareas?')) {
			var ntger = this.state.integers
			for (var k = 0; k < ntger.length; k++) {
				if (ntger[k].Usser[0].tassk.length >= 1) {
					console.log(ntger[k].Usser[0].tassk[0]._id)
					await axios.delete(`${process.env.REACT_APP_API_URL}/tasks/${ntger[k].Usser[0].tassk[0]._id}`).then(res => {
						console.log(res)
					})
					//this.loading = "false"
					// this.themesService.deletetask(ntger[k].Usser[0].tassk[0]._id)
					// 	.subscribe(res => {
					// 		this.gettheme()
					// 	})
				} else {
					console.log('www');
				}
			}
			this.getNotes()
		}
	}

	onInputChange = (e) => {
		console.log(e.target.name, e.target.value);
		this.setState({ [e.target.name]: e.target.value })
	};


	cleantaskone = async (_id) => {
		if (window.confirm('Desea eliminar la tarea?')) {
			await axios.delete(`${process.env.REACT_APP_API_URL}/tasks/${_id}`).then(res => {
				console.log(res)
			})
			this.getNotes()
			this.getStdNativescalification()
		}
	}

	onSubmitRemove = async () => {
		const response = window.confirm('Deseas eliminar este capítulo?');
		if (response) {
			await axios.delete(`${process.env.REACT_APP_API_URL}/seccions/` + this.state.id);
			this.getNotes();
			toast.dark('Removido correctamente');
		}
	};

	getStdNativescalification = async () => {
		// console.log(idcurse, codetheme)
		const res = await axios.get(
			`${process.env.REACT_APP_API_URL}/users/themeusers/${this.state.id}/${this.props.match.params.theme}`
		);
		this.setState({
			stdaverages: res.data,
		});
		console.log(res, "wwwwwwwzzz")

	};

	removeaddedcurse = async (idmycurse) => {
		const response = window.confirm('Deseas eliminar estudiante de este curso?');
		if (response) {
			await axios.delete(`${process.env.REACT_APP_API_URL}/curses/generate/` + idmycurse);
			this.getStdNativescalification();
			toast.dark('Removido correctamente');
		}
	};


	render() {
		return (
			<div>
				<ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />
				<Headroom>
					<Navigation />
				</Headroom>
				{/* <button onClick={reactToPrintFn}>Imprimir sesión</button> */}
				{/* <button onClick={this.calificationclean()}>Imprimir sesión</button> */}
				{/* <div ref={(refer) => (this.componentRef = refer)}>Export my HTMl component to a PDF File</div>
						<ReactToPrint
							content={() => this.componentRef}
							trigger={() => (
								<button className="btn btn-primary">Print to PDF!</button>
							)}
						/>
						*/}
				{/* <WindowFocusHandler /> */}

				<div className='container'>

					{isAuth().rol === "1" ?
						<button className="btn btn-info text-center w-100" onClick={() => { this.open(); this.setState({ option: true, title: '', detail: '' }) }} > Editar </button>
						: ''}
					{/* {this.props.match.params.title} wwwwwwwwwwwwwwwwwwwwwwwwwwww */}

					<h5 className="text-center">
						<span className='ffont h3 text-info'> {this.props.location.state.title}</span> <span className='ffont h1 text-center text-dark'>[{this.props.location.state.unittitle}] </span>
					</h5>

					<Modal show={this.state.showModal} onHide={() => { this.close(); }} animation={false}>
						<div className="modal-header font-weight-bold h5">Actualizar</div>
						<div className="modal-body">
							<div className="mb-3">
								<label className="form-label">Detalle (Escriba texto en formato Markdown [<a href="https://www.markdownguide.org/basic-syntax/" target="_blank">Tutorial!</a>])</label>
								<textarea type="text" className="form-control scroll" placeholder="Contenido" rows="9" name="description" onChange={this.onInputChange} value={this.state.description} required ></textarea>
								<Markdownkatexnew>
									{this.state.description}
								</Markdownkatexnew>
							</div>
						</div>
						<div className="modal-footer d-flex right-content-center">
							<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={this.submitTest}> Actualizar </button>
							<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.close() }}> Close </button>
						</div>
					</Modal >
					<div className='rounded border' style={{ backgroundColor: 'white', padding: '3px' }}>
						<Markdownkatexnew>
							{this.state.description}
						</Markdownkatexnew>
					</div>

					{/* {this.state.tassks.length > 0 ? */}
					<div className='rounded'>
						{isAuth().rol === "1" ?
							<button className='btn btn-primary w-100 mt-1' onClick={() => { this.createTask() }}>Crear tarea</button>
							: ''}

						{this.state.tasskstd.length > 0 ?
							<div className="text-center p-1" style={{ margin: '.1em' }} >
								<Task idtheme={this.props.match.params.theme} codetheme={this.props.match.params.curse} task_id={this.state.tasskstd[0]._id} themetitle={this.state.title} />
							</div>
							: <>
								{this.state.dateb < this.state.noww && this.state.noww < this.state.datee ? <button className='btn btn-primary w-100' style={{ display: this.state.tassks.length === 0 ? 'none' : '' }} disabled={this.state.isDisabled} onClick={() => { this.getRandomIntInclusive(0, this.state.tassks.length) }} >Generar test (Acumular crédito)</button> : <div className="text-center">Intervalo de sesión culminada (No generó test)</div>}
							</>
						}

						{isAuth().rol === '1' ?
							<div className="row d-flex justify-content-center">
								{this.state.tassks.map((notew) => (
									<div className="text-center col-md-3 p-1" style={{ margin: '.1em' }} key={notew._id} >
										<div className='rounded' style={{ backgroundColor: this.state.dateb < this.state.noww && this.state.noww < this.state.datee ? 'orange' : 'skyblue' }}>
											[{notew.task.length}-{notew.solution.length}]
											{/* Inició <TimeAgo datetime={notew.dateb} locale='es' />. Culnima <TimeAgo datetime={notew.datee} locale='es' /> */}
											<div className="p-1 btn-group w-100">
												<Link className="btn w-100 btn-primary" to={'/test/' + notew._id} >
													Actualizar
												</Link>
												<button className="btn btn-secondary w-100" onClick={() => { this.cleantaskone(notew._id) }}>
													Borrar
												</button>
											</div>
										</div>
									</div>
								))}
							</div> : null}
					</div>
					{/* : ''} */}

					{isAuth().rol === "1" ?
						<div className="p-1 rounded my-3" style={{ backgroundColor: this.state.dateb < this.state.noww && this.state.noww < this.state.datee ? 'Gold' : 'WhiteSmoke' }}>
							<IA tittle={this.props.location.state.title} />
							{this.state.dateb < this.state.noww && this.state.noww < this.state.datee ?
								<div className="h3 w-100 text-center ffont" style={{ fontWeight: 'bold' }}>FECHA ACTIVADA</div> :
								<div className="h3 w-100 text-center ffont" style={{ fontWeight: 'bold' }}>FECHA NO ACTIVADA</div>
							}
							<div className="row p-1 d-flex justify-content-center align-items-center">
								<div className="col-md-6 p-1 text-center">
									Inicia <TimeAgo datetime={this.state.dateb} locale='es' />
									<br /><DatePicker className='btn btn-info w-100' locale="es" showTimeSelect showIcon dateFormat="Pp"
										selected={this.state.dateb}
										onChange={(date) => {
											this.setState({ noww: new Date(), dateb: date })
										}}
									/>
								</div>
								<div className="col-md-6 p-1 text-center">
									Culmina <TimeAgo datetime={this.state.datee} locale='es' /><br />
									<DatePicker className='btn btn-info w-100' locale="es" showTimeSelect showIcon dateFormat="Pp"
										selected={this.state.datee}
										onChange={(date) => {
											this.setState({ noww: new Date(), datee: date })
										}}
									/>
								</div>
								<div className="col-md-2 p-1 text-center">
									Tiempo de examen<br />
									<input className="form-control" name="timetest" type="number" value={this.state.timetest ?? ''} onChange={this.onInputChange} step="1" min="0" max="100" />
								</div>
							</div>
							<button className='btn btn-info w-100 my-1' onClick={this.submitTest}>Actualizar campos</button>
							<button className='btn btn-danger w-100' onClick={this.onSubmitRemove}>Remover sesión</button>
						</div>
						: ''}


					{isAuth().rol === '1' ? <div className="p-1 text-center">
						<div className="row justify-content-center align-items-center">
							{this.state.stdaverages.map((note, index) => (
								<div className="col-md-4 p-1 m-0 text-center" key={index}>
									<div className="border rounded p-1">
										<button className='form-control btn btn-info' onClick={() => { this.removeaddedcurse(note._id) }}>Remover del curso</button>
										{note.usser[0] ? note.usser[0].email : ''}<br />
										{note.usser[0] && note.usser[0].tassk[0] ?
											<>
												<Tassk idtheme={this.props.match.params.theme} codetheme={this.props.match.params.curse} usser={note.usser[0]._id} />
												<button className="btn btn-warning w-100" onClick={() => { this.cleantaskone(note.usser[0].tassk[0]._id) }}>
													Borrar tarea
												</button>
											</>
											: ''}
									</div>
								</div>
							))}
						</div>
					</div> : ''}

					<div className="py-3"></div>
				</div >
			</div>)
	}
}

